"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.updateUserClientSettingsError = exports.updateUserClientSettingsSuccess = exports.updateUserClientSettings = exports.loadOneUserClientError = exports.loadOneUserClientSuccess = exports.loadOneUserClient = exports.resetUserClients = exports.setCurrentUserClientId = exports.loadUserClientsError = exports.loadUserClientsSuccess = exports.loadUserClients = void 0;

var loadUserClients = function loadUserClients(payload) {
  return {
    type: 'OLY_ENGINE_STORE_LOAD_USER_CLIENTS',
    payload: payload
  };
};

exports.loadUserClients = loadUserClients;

var loadUserClientsSuccess = function loadUserClientsSuccess(userClients) {
  return {
    type: 'OLY_ENGINE_STORE_LOAD_USER_CLIENTS_SUCCESS',
    payload: {
      userClients: userClients
    }
  };
};

exports.loadUserClientsSuccess = loadUserClientsSuccess;

var loadUserClientsError = function loadUserClientsError(error) {
  return {
    type: 'OLY_ENGINE_STORE_LOAD_USER_CLIENTS_ERROR',
    payload: {
      error: error
    }
  };
};

exports.loadUserClientsError = loadUserClientsError;

var setCurrentUserClientId = function setCurrentUserClientId(clientId) {
  return {
    type: 'OLY_ENGINE_STORE_SET_CURRENT_USER_CLIENT_ID',
    payload: {
      clientId: clientId
    }
  };
};

exports.setCurrentUserClientId = setCurrentUserClientId;

var resetUserClients = function resetUserClients() {
  return {
    type: 'OLY_ENGINE_STORE_RESET_USER_CLIENTS'
  };
};

exports.resetUserClients = resetUserClients;

var loadOneUserClient = function loadOneUserClient(payload) {
  return {
    type: 'OLY_LOAD_ONE_USER_CLIENT',
    payload: payload
  };
};

exports.loadOneUserClient = loadOneUserClient;

var loadOneUserClientSuccess = function loadOneUserClientSuccess(userClient) {
  return {
    type: 'OLY_LOAD_ONE_USER_CLIENT_SUCCESS',
    payload: {
      userClient: userClient
    }
  };
};

exports.loadOneUserClientSuccess = loadOneUserClientSuccess;

var loadOneUserClientError = function loadOneUserClientError(error) {
  return {
    type: 'OLY_LOAD_ONE_USER_CLIENT_ERROR',
    payload: {
      error: error
    }
  };
};

exports.loadOneUserClientError = loadOneUserClientError;

var updateUserClientSettings = function updateUserClientSettings(payload) {
  return {
    type: 'OLY_UPDATE_USER_CLIENT_SETTINGS',
    payload: payload
  };
};

exports.updateUserClientSettings = updateUserClientSettings;

var updateUserClientSettingsSuccess = function updateUserClientSettingsSuccess(settings) {
  return {
    type: 'OLY_UPDATE_USER_CLIENT_SETTINGS_SUCCESS',
    payload: {
      settings: settings
    }
  };
};

exports.updateUserClientSettingsSuccess = updateUserClientSettingsSuccess;

var updateUserClientSettingsError = function updateUserClientSettingsError(error) {
  return {
    type: 'OLY_UPDATE_USER_CLIENT_SETTINGS_ERROR',
    payload: {
      error: error
    }
  };
};

exports.updateUserClientSettingsError = updateUserClientSettingsError;
var _default = {
  loadUserClients: loadUserClients,
  loadUserClientsSuccess: loadUserClientsSuccess,
  loadUserClientsError: loadUserClientsError,
  setCurrentUserClientId: setCurrentUserClientId,
  resetUserClients: resetUserClients,
  loadOneUserClient: loadOneUserClient,
  loadOneUserClientSuccess: loadOneUserClientSuccess,
  loadOneUserClientError: loadOneUserClientError,
  updateUserClientSettings: updateUserClientSettings,
  updateUserClientSettingsSuccess: updateUserClientSettingsSuccess,
  updateUserClientSettingsError: updateUserClientSettingsError
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map